import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { Product, Farm } from '../../../models/types';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { OrganisationServiceService } from '../../services/organisation-service.service';

@Component({
  selector: 'app-add-product-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, FontAwesomeModule],
  templateUrl: './add-product-modal.component.html',
  styleUrls: ['./add-product-modal.component.scss']
})
export class AddProductModalComponent {
  @Input() farm!: Farm;

  newProduct: Product = {
    productID: 0,
    farmID: 0,
    name: '',
    description: '',
    cost: 0,
    quantity: 0,
    type: 'ostalo',
    image: ''
  };

  previewImageSrc: string | ArrayBuffer | null = null;
  imageFile: File | undefined;
  faImage = faImage;

  constructor(
    public activeModal: NgbActiveModal,
    private profilePageService: ProfilePageService,
    private organisationService: OrganisationServiceService
  ) {}

  onImageUploadChanged(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.organisationService.compressImage(file, 70, 50).then((compressedFile) => {
        this.imageFile = compressedFile;
        this.previewImageSrc = URL.createObjectURL(compressedFile);
      }).catch(error => console.error('Error compressing image:', error));
    }
  }

  addNewProduct(): void {
    if (!this.newProduct.name|| !this.newProduct.description) {
      console.error('Form is incomplete');
      return;
    }

    // Add the product first
    this.profilePageService.addProduct(this.farm.farmID, this.newProduct).subscribe(
      (response) => {
        console.log('Product added successfully:', response);
        // Store the product ID from the response
        const productID = response.productID; // Adjust based on your actual response structure
        if (this.imageFile) {
          // If an image file is selected, upload it after the product is added
          this.uploadImageFile(productID);
        } else {
          this.resetAndCloseModal();
        }
      },
      (error) => {
        console.error('Error adding product:', error);
      }
    );
  }

  uploadImageFile(productID: number): void {
    this.profilePageService.uploadImageFile({
      picture: this.imageFile!,
      productID: productID
    }).subscribe({
      next: (data) => {
        console.log('Image uploaded successfully:', data);
        // Update the product's image reference after successful image upload
        this.newProduct.image = data.imageURL; // Assuming response contains the image URL or path
        this.resetAndCloseModal();
      },
      error: (error) => {
        console.error('Error uploading image:', error);
      }
    });
  }

  resetAndCloseModal(): void {
    this.newProduct = {
      productID: 0,
      farmID: 0,
      name: '',
      description: '',
      cost: 0,
      quantity: 0,
      type: 'ostalo',
      image: ''
    };
    this.activeModal.close(); // Close the modal after successful add and image upload
    //window.location.reload();
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
